import React from 'react';
import Player from 'video.js/dist/types/player';
import VideoJS from './VideoJS';
export type VideoPlayerProps = {
  src: string;
  autoplay?: boolean | 'muted';
  loop?: boolean;
  controls?: boolean;
};
export function VideoPlayer({
  src,
  ...props
}: VideoPlayerProps) {
  const playerRef = React.useRef<null | Player>(null);
  const videoJsOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    ...props,
    sources: [{
      src,
      type: 'video/mp4'
    }]
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePlayerReady = (player: any) => {
    playerRef.current = player;
    setTimeout(() => {
      if (!props.autoplay) {
        player.pause();
      }
    }, 10000);
  };
  return <div style={{
    position: 'relative'
  }} data-sentry-component="VideoPlayer" data-sentry-source-file="VideoPlayer.tsx">
      <div onClick={() => {
      if (playerRef.current?.paused()) {
        playerRef.current?.play();
      } else {
        playerRef.current?.pause();
      }
    }} style={{
      position: 'absolute',
      width: '100%',
      height: '90%',
      zIndex: 100
    }}></div>
      <VideoJS options={videoJsOptions} onReady={handlePlayerReady} data-sentry-element="VideoJS" data-sentry-source-file="VideoPlayer.tsx" />
    </div>;
}